export const getDays = i18n => ({
  id: 'CallbackForm-callbackDay',
  name: 'CallbackForm-callbackDay',
  label: 'Day',
  showLabel: false,
  options: [
    {
      value: 'monday',
      text: i18n._('general.label.day.monday'),
    },
    {
      value: 'tuesday',
      text: i18n._('general.label.day.tuesday'),
    },
    {
      value: 'wednesday',
      text: i18n._('general.label.day.wednesday'),
    },
    {
      value: 'thursday',
      text: i18n._('general.label.day.thursday'),
    },
    {
      value: 'friday',
      text: i18n._('general.label.day.friday'),
    },
  ],
})

export const HOURS = {
  id: 'CallbackForm-callbackMonth',
  name: 'CallbackForm-callbackMonth',
  label: 'Hour',
  showLabel: false,
  options: [
    {
      value: '08',
      text: '08',
    },
    {
      value: '09',
      text: '09',
    },
    {
      value: '10',
      text: '10',
    },
    {
      value: '11',
      text: '11',
    },
    {
      value: '12',
      text: '12',
    },
    {
      value: '13',
      text: '13',
    },
    {
      value: '14',
      text: '14',
    },
    {
      value: '15',
      text: '15',
    },
    {
      value: '16',
      text: '16',
    },
    {
      value: '17',
      text: '17',
    },
    {
      value: '18',
      text: '18',
    },
    {
      value: '19',
      text: '19',
    },
  ],
}

export const MINUTES = {
  id: 'CallbackForm-callbackMinute',
  name: 'CallbackForm-callbackMinute',
  label: 'Minutes',
  showLabel: false,
  options: [
    {
      value: '00',
      text: '00',
    },
    {
      value: '15',
      text: '15',
    },
    {
      value: '30',
      text: '30',
    },
    {
      value: '45',
      text: '45',
    },
  ],
}

export const PRODUCT_TYPE = 'product'
export const ORDER_TYPE = 'order'
